package com.neurobs.ccabserver.translationadmin.components.testupload

import com.neurobs.ccabserver.translationadmin.components.testupload.components.{CCABDiff, FileUploadInput, TestSaveInput}
import com.neurobs.react.{ReactElementFactory, ReactUtil}
import com.neurobs.react.semanticui.{UiDividerFactory, UiGridFactory}
import slinky.core.FunctionalComponent
import slinky.core.annotations.react
import slinky.core.facade.{React, ReactElement}

@react
object TestUpload {
  case class Props()
  val component = FunctionalComponent[Props] { props =>

    UiGridFactory.Grid(
      UiGridFactory.GridColumn(
        FileUploadInput(
          enclosingElement = ReactElementFactory.Div(_)
        ),
        UiDividerFactory.Horizontal,
        TestSaveInput(
          enclosingElement = ReactElementFactory.Div(_)
        )
      )("six wide center aligned"),
      CCABDiff(
        enclosingElement = UiGridFactory.GridColumn(_)("ten wide")
      )
    )


  }
}
